import Form from 'react-bootstrap/Form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const JumbleBotSwitch = (props: { journalAssistant: boolean; onClick: () => void }) => {
  const { onClick, journalAssistant } = props;

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="word-count-tooltip">
            Click here to turn on Jumble Bot. Then, press 'Enter' while journaling to interact with Jumble Bot.
          </Tooltip>
        }
      >
        <>
          <div className="tw-font-normal tw-text-neutral-800 lg:tw-text-base tw-text-sm">AI Assistant</div>
          <Form.Check
            onMouseEnter={(e) => ((e.target as any).style.cursor = 'pointer')} // Change cursor to pointer on hover
            onMouseLeave={(e) => ((e.target as any).style.cursor = 'default')} // Revert cursor to default when leaving
            type="switch"
            id="custom-switch"
            label=""
            checked={journalAssistant}
            onChange={onClick}
          />
        </>
      </OverlayTrigger>
    </>
  );
};
